<template>
  <div class="mx-auto py-1 px-2 top-btn-toggle-sticky">
    <v-btn-toggle v-model="internalTab" mandatory class="btn-toggle text-center w-100">
      <v-btn v-if="hasGeneral" class="flex-1" value="general">{{ $t("general") }}</v-btn>
      <v-btn v-if="hasOptions" class="flex-1" value="options">{{ $t("options") }}</v-btn>
      <v-btn v-if="hasActions" class="flex-1" value="actions">{{ $t("actions") }}</v-btn>
    </v-btn-toggle>
  </div>

  <div v-if="internalTab === 'general' && hasGeneral">
    <slot name="general" />
  </div>
  <div v-else-if="internalTab === 'options' && hasOptions">
    <slot name="options" />
  </div>
  <div v-else-if="internalTab === 'actions' && hasActions">
    <slot name="actions" />
  </div>
</template>

<script>
  export default {
    name: "SettingsTabs",
    props: {
      modelValue: {
        type: String,
        default: "general",
      },
    },
    computed: {
      internalTab: {
        get() {
          return this.modelValue;
        },
        set(val) {
          this.$emit("update:modelValue", val);
        },
      },

      hasGeneral() {
        return !!this.$slots.general;
      },
      hasOptions() {
        return !!this.$slots.options;
      },
      hasActions() {
        return !!this.$slots.actions;
      },
    },
  };
</script>
